interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黄游网页版',
    url: 'https://huangyou.com/',
    description: '黄游网页版是无需下载安装、直接在浏览器中畅玩的游戏平台。支持PC与手机端访问，海量游戏资源随时体验。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'service@huangyou.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黄游网页版',
    url: 'https://huangyou.com/',
    description: '黄游网页版是无需下载安装、直接在浏览器中畅玩的游戏平台。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://huangyou.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: data.name || '黄游网页版',
    description: data.description || '黄游网页版在线游戏平台',
    url: data.url || 'https://huangyou.com/',
    ...data,
  };

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: (data as { headline?: string }).headline || '',
    description: (data as { description?: string }).description || '',
    author: {
      '@type': 'Person',
      name: (data as { author?: string }).author || '黄游网页版',
    },
    datePublished: (data as { datePublished?: string }).datePublished || '',
    dateModified: (data as { dateModified?: string }).dateModified || '',
    publisher: {
      '@type': 'Organization',
      name: '黄游网页版',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: ((data as { questions?: Array<{ question: string; answer: string }> }).questions || []).map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  };

  let schema;
  switch (type) {
    case 'Organization':
      schema = organizationSchema;
      break;
    case 'WebSite':
      schema = websiteSchema;
      break;
    case 'WebPage':
      schema = webpageSchema;
      break;
    case 'Article':
      schema = articleSchema;
      break;
    case 'FAQPage':
      schema = faqSchema;
      break;
    default:
      schema = webpageSchema;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}